import type { ListenerEffectAPI, PayloadAction } from "@reduxjs/toolkit";
import { isAnyOf } from "@reduxjs/toolkit";
import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import type { TSetSelectedObjectIDPayload } from "../../../../../app/state/storageObjectSlice/types";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { serviceHandlers } from "../handlers/storageHandlers";
import { fetchStorageObjectById } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { setLastSelectedId } from "../../../../../app/state/storageObjectSlice/utils/setLastSelectedId";
import { dispatchCancellable } from "../../../../lib/dispatchCancellable";

export function selectStorageObjectListener() {
  appListenerMiddleware.startListening({
    matcher: isAnyOf(setSelectedObjectId),
    effect: async (
      action: PayloadAction<TSetSelectedObjectIDPayload>,
      listenerApi,
    ) => {
      listenerApi.cancelActiveListeners();
      const { service, id, skipSelectHandler, newValue } = action.payload;
      if (!id || skipSelectHandler) return;

      const { selectedId } = (listenerApi.getOriginalState() as RootState)
        .storageObjectState[service];

      let value = newValue;
      if (!value) {
        const result = await dispatchCancellable(listenerApi.signal, () =>
          listenerApi.dispatch(fetchStorageObjectById({ service, id })),
        );
        if (result === undefined) return;
        value = result.value;
      }

      const handler = serviceHandlers[service];

      setLastSelectedId(id, service);

      if (handler?.onSelect) {
        await handler.onSelect(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
          id,
          value,
          selectedId,
        );
      }
    },
  });
}
